import { templateDto } from "../app/model/api/types/dto/templateDto";

export class TemptEmailViewModel {
    id?: string | null;
    parentTemplateId: string | null;
    communicationTypeId: string | null;
    fromEmailAddress: string | null;
    fromName: string | null;
    maxProcessTime: string | null;
    minProcessTime: string | null;
    subject: string | null;
    templateDescription: string | null;
    templateName: string | null;
    textContent: string | null;
    htmlContent: string | null;
    isActive: boolean | null;
    isArchived: boolean | null;
    isDeleted: boolean | null;
    lockLifespanSeconds: number | null;
    requestLifespanSeconds: number | null;
    maxAttempts: number | null;
    periodEnd: Date | string | null;
    periodStart: Date | string | null;
    recordVersion: string | null;

    constructor(
        id: string | null,
        parentTemplateId: string | null,
        communicationTypeId: string | null,
        fromEmailAddress: string | null,
        fromName: string | null,
        maxProcessTime: string | null,
        minProcessTime: string | null,
        subject: string | null,
        templateDescription: string | null,
        templateName: string | null,
        textContent: string | null,
        htmlContent: string | null,
        isActive: boolean | null,
        isArchived: boolean | null,
        isDeleted: boolean | null,
        lockLifespanSeconds: number | null,
        requestLifespanSeconds: number | null,
        maxAttempts: number | null,
        periodEnd: Date | string | null,
        periodStart: Date | string | null,
        recordVersion: string | null,
    ) {
        this.id = id
        this.parentTemplateId = parentTemplateId;
        this.communicationTypeId = communicationTypeId;
        this.fromEmailAddress = fromEmailAddress;
        this.fromName = fromName;
        this.maxProcessTime = maxProcessTime;
        this.minProcessTime = minProcessTime;
        this.subject = subject;
        this.templateDescription = templateDescription;
        this.templateName = templateName;
        this.textContent = textContent;
        this.htmlContent = htmlContent;
        this.isActive = isActive;
        this.isArchived = isArchived;
        this.isDeleted = isDeleted;
        this.lockLifespanSeconds = lockLifespanSeconds;
        this.requestLifespanSeconds = requestLifespanSeconds;
        this.maxAttempts = maxAttempts;
        this.periodEnd = periodEnd;
        this.periodStart = periodStart;
        this.recordVersion = recordVersion;
    }

    toDto(): templateDto {
        return {
            id: this.id,
            parentTemplateId: this.parentTemplateId,
            communicationTypeId: this.communicationTypeId,
            fromEmailAddress: this.fromEmailAddress,
            fromName: this.fromName,
            maxProcessTime: this.maxProcessTime,
            minProcessTime: this.minProcessTime,
            subject: this.subject,
            templateDescription: this.templateDescription,
            templateName: this.templateName,
            textContent: this.textContent,
            htmlContent: this.htmlContent,
            isActive: this.isActive,
            isArchived: this.isArchived,
            isDeleted: this.isDeleted,
            lockLifespanSeconds: this.lockLifespanSeconds,
            requestLifespanSeconds: this.requestLifespanSeconds,
            maxAttempts: this.maxAttempts,
            periodEnd: this.periodEnd,
            periodStart: this.periodStart,
            recordVersion: this.recordVersion,
        };
    }

    mapFromDto(dto: templateDto): void {
        this.id = dto.id;
        this.parentTemplateId = dto.parentTemplateId;
        this.communicationTypeId = dto.communicationTypeId;
        this.fromEmailAddress = dto.fromEmailAddress;
        this.fromName = dto.fromName;
        this.maxProcessTime = dto.maxProcessTime;
        this.minProcessTime = dto.minProcessTime;
        this.subject = dto.subject;
        this.templateDescription = dto.templateDescription;
        this.templateName = dto.templateName;
        this.textContent = dto.textContent;
        this.htmlContent = dto.htmlContent;
        this.isActive = dto.isActive !== undefined ? dto.isActive : null;
        this.isArchived = dto.isArchived !== undefined ? dto.isArchived : null;
        this.isDeleted = dto.isDeleted !== undefined ? dto.isDeleted : null;
        this.lockLifespanSeconds = dto.lockLifespanSeconds;
        this.requestLifespanSeconds = dto.requestLifespanSeconds;
        this.maxAttempts = dto.maxAttempts;
        this.periodEnd = dto.periodEnd;
        this.periodStart = dto.periodStart;
        this.recordVersion = dto.recordVersion;
    }
}
